var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenTab = function SvgOpenTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 11.022a1 1 0 0 1-1 1H11a1 1 0 1 1 0-2h28a1 1 0 0 1 1 1M69 69.537a1 1 0 0 1-1-1v-29.46a1 1 0 1 1 2 0v29.46a1 1 0 0 1-1 1",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10 69.979V10.022h2v59.957z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M70 70H10v-2h60zM60.634 19.097a1 1 0 0 1 .011 1.414L30.713 50.936a1 1 0 1 1-1.426-1.402L59.22 19.108a1 1 0 0 1 1.414-.011",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M50.079 9.612A1 1 0 0 1 51 9h18.974a1 1 0 0 1 1 1v19.457a1 1 0 0 1-1.716.698L50.284 10.698a1 1 0 0 1-.206-1.086M53.372 11l15.602 15.999V11z",
    clipRule: "evenodd"
  })));
};
export default SvgOpenTab;